import { defaultIconProps, IconProps } from './IconProps';

export const IconSkipPrev: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M14.1666 15L9.16663 10L14.1666 5" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.83337 5V15" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconSkipPrev.defaultProps = defaultIconProps;
